/**
 * jQuery SmartCrop v2.0.0
 * Copyright (c) 2017 Greg Schoppe
 * License: http://www.opensource.org/licenses/mit-license.php
 **/
/* eslint-disable */
(function($){
	$.fn.extend({ 'wpsmartcrop' : function(options) {
		var options = $.extend({
			 // array of percentages [x, y] denoting the position
			 // of the focal point in the image (example: [16, 78])
			'focal_point'   : null,
			// set to 'new' to force "objectFit" mode or
			// set to 'old' to force "overflow: hidden" mode
			'compatibility' : 'old',
			// set to 'power-lines' to match focal points to rule-of-thirds or centers
			// set to 'relative' to try to maintain the relative focal position
			'focus_mode'    : 'power-lines'
		}, options);

		// localized version of a request animation frame polyfill by paul irish
		var lastTime = 0;
		var vendors = ['webkit', 'moz'];
		var requestFrame = window.requestAnimationFrame;
		var cancelFrame = window.cancelAnimationFrame;
		for(var x = 0; x < vendors.length && !requestFrame; ++x) {
			requestFrame = window[vendors[x]+'RequestAnimationFrame'];
			cancelFrame = window[vendors[x]+'CancelAnimationFrame'] || window[vendors[x]+'CancelRequestAnimationFrame'];
		}
		if (!requestFrame) {
			requestFrame = function(callback, element) {
				var currTime = new Date().getTime();
				var timeToCall = Math.max(0, 16 - (currTime - lastTime));
				var id = window.setTimeout(function() {
					callback(currTime + timeToCall);
				}, timeToCall);
				lastTime = currTime + timeToCall;
				return id;
			};
		}
		if (!cancelFrame) {
			cancelFrame = function(id) {
				clearTimeout(id);
			};
		}
		// END requestAnimationFrame polyfill

		// check if the browser supports objectfit
		var browser_supports_object_fit = false;
		// get the closest value in an array to a specific number
		function closest( num, arr ) {
			var curr = arr[0];
			var diff = Math.abs( num - curr );
			for( var val = 0; val < arr.length; val++ ) {
				var newdiff = Math.abs( num - arr[val] );
				if( newdiff < diff ) {
					diff = newdiff;
					curr = arr[val];
				}
			}
			return curr;
		}
		// calculating the dimensions of a proportional image that
		// will cover the target used for overflow:hidden mode
		function get_final_image_dims( natural_dims, target_dims ) {
			var natural_ratio = natural_dims[0]/natural_dims[1];
			var target_ratio  = target_dims[0]/target_dims[1];
			if( natural_ratio > target_ratio ) {
				return [
					Math.round(target_dims[1] * natural_ratio),
					target_dims[1]
				];
			}
			return [
				target_dims[0],
				Math.round(target_dims[0] / natural_ratio)
			];
		}
		// get dimensions to crop element to put the focus as close to a rule of
		// thirds line, or the center, as possible
		function get_crop_data($el) {
			var get_smartcrop_offset = function(dim, orig_dim, focus_pos, focus_mode) {
				if( !focus_mode ) {
					focus_mode = 'power-lines';
				}
				focus_pos = focus_pos / 100;
				var focus_target = focus_pos,
					max = orig_dim - dim,
					offset;
				if( focus_mode == 'power-lines' ) {
					focus_target = closest(focus_pos, [.33333, .5, .66667]);
				}
				offset = Math.round(focus_pos * orig_dim - focus_target * dim);
				if(offset > max) {
					offset = max;
				}
				if(offset < 0) {
					offset = 0;
				}
				return -1 * offset;
			};
			var focal_point  = $el.data('smartcrop-focus'),
				focus_mode   = $el.data('smartcrop-mode'),
				natural_dims = [
					( $el[0].naturalWidth  ) ? $el[0].naturalWidth  : $el[0].getAttribute('width'),
					( $el[0].naturalHeight ) ? $el[0].naturalHeight : $el[0].getAttribute('height')
				],
				target_dims  = [
					$el.width(),
					$el.height()
				],
				final_dims = get_final_image_dims( natural_dims, target_dims ),
				offsets = [0,0];
			if( !focal_point ) {
				focal_point = options.focal_point;
			}
			if( !focal_point || focal_point.length < 2 ||
				!natural_dims[0] || !natural_dims[1] ||
				!target_dims[0] || !target_dims[1] ) {
				return false;
			}
			if( !focus_mode ) {
				if( typeof window.wpsmartcrop_focus_mode !== 'undefined' ) {
					focus_mode = options.focus_mode;
				} else {
					focus_mode = "power-lines";
				}
			}
			if( target_dims[0]/target_dims[1] < final_dims[0]/final_dims[1] ) {
				offsets[0] = get_smartcrop_offset(target_dims[0], final_dims[0], focal_point[0], focus_mode);
			} else {
				offsets[1] = get_smartcrop_offset(target_dims[1], final_dims[1], focal_point[1], focus_mode);
			}
			return {
				final_width  : final_dims[0],
				final_height : final_dims[1],
				offset_x     : offsets[0],
				offset_y     : offsets[1]
			};
		}
		function recrop_images( $el, use_object_fit ) {
			var crop = get_crop_data($el);
			// for browsers that support object-position and object-fit
			if( use_object_fit ) {
				var position_val = '' + crop.offset_x + 'px ' + '' + crop.offset_y + 'px';
				$el.css({
					'-o-object-position' : position_val,
					'object-position'    : position_val
				});
				$el.addClass('wpsmartcrop-rendered');
			} else {
				var $overlay = $el.next('.wpsmartcrop-overlay');

        $overlay.css({
					'background-position-y'  : crop.offset_y  + 'px',
					'background-position-x'  : crop.offset_x  + 'px',
          'background-size'   : 'cover',
          'background-repeat' : 'no-repeat',
          'width'   : '100%',
          'height'   : '100%',
          'position'   : 'absolute',
          'background-image': 'url(' + $el.attr('src') + ')',
          'top': '0',
				});
        $el.addClass('image-cropped');

        $overlay.addClass('wpsmartcrop-overlay-rendered');
			}
		}
		return this.each(function() {
			var $this = $(this);
			// $this needs to be an image
			if( !$this.is('img') ) {
				return;
			}
			// the image needs to have dimensions
			var natural_dims  = [
				( $this[0].naturalWidth  ) ? $this[0].naturalWidth  : $this[0].getAttribute('width'),
				( $this[0].naturalHeight ) ? $this[0].naturalHeight : $this[0].getAttribute('height')
			];
			if( natural_dims[0] == 0 || natural_dims[1] == 0 ) {
				return;
			}
			// we'll need those for cropping
			$this.data( 'wpsmartcrop-natural-dims', natural_dims );
			// kill any existing overlay
			$this.next('wpsmartcrop-overlay').remove();
			// set the focus if we don't have one... if all else fails, make the focus the center
			if( options['focal_point'] ) {
				$this.data('smartcrop-focus', options['focal_point'] );
			} else {
				if( !$this.data('smartcrop-focus') ) {
					$this.data('smartcrop-focus', [50, 50] );
				}
			}
			// decide whether the browser supports objectFit, or just force one mode in options
			var use_object_fit = true;
			if( options['compatibility'] != 'new' ) {
				if( ( options['compatibility'] == 'old' ) || !browser_supports_object_fit ) {
					use_object_fit = false;
					var $image_overlay = $('<div></div>').addClass('wpsmartcrop-overlay');
					$image_overlay.insertAfter($this);
				}
			}
			recrop_images( $this, use_object_fit );
			var resizer_frame_request = false;
			$(window).resize(function() {
				cancelFrame( resizer_frame_request );
				resizer_frame_request = requestFrame(function() {
					recrop_images( $this, use_object_fit );
				});
			});
			$(window).on('load', function() {
				recrop_images( $this, use_object_fit );
			});
			$this.on('wpsmartcrop-redraw', function() {
				recrop_images( $this, use_object_fit );
			});
		});
	}});
}(jQuery));

// initialize for wp-smartcrop wordpress plugin
jQuery(document).ready(function($) {
	if( typeof wpsmartcrop_options === 'undefined' ) {
		wpsmartcrop_options = {};
	}
	var init = function() {
		$('img.wpsmartcrop-image, .featured-content__image img').wpsmartcrop(wpsmartcrop_options);
	};
	init();
	// mutation observer to make smartcrop run after ajax actions
});



// WEBPACK FOOTER //
// ./scripts/smartcrop.js